import { takeLatest, select, put, all } from 'redux-saga/effects'
import { pathOr, isNil } from 'ramda'
import {
  LINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM,
  BATCH_IMPORT_COMPLETE,
} from 'actions/referenceParameter'
import { isSPValid } from 'utils/referenceParameter'
import { getCurrRPSPs } from 'selectors/referenceParameter'
import { getSPOnly } from 'selectors/supportParameter'
import {
  setCurrentFieldValidity,
  DUPLICATE_SUPPORT_PARAM,
} from 'actions/supportParameter'
import { createSystemNotification } from 'actions/application'
import { NOTIFICATION_ERROR } from 'utils/constants'
import { SP_EDITOR_VALIDITY_NOTIFY } from 'utils/notifications'

export default function* watchSPDuplicate() {
  yield takeLatest(
    [
      LINK_SUPPORT_PARAM_TO_CURRENT_REFERENCE_PARAM,
      DUPLICATE_SUPPORT_PARAM,
      BATCH_IMPORT_COMPLETE,
    ],
    checkSPValidity
  )
}

function* helper(sp, siblingSPs) {
  const spConflict = yield isSPValid(sp, siblingSPs)
  if (spConflict) {
    yield put(
      setCurrentFieldValidity(
        false,
        spConflict.type,
        spConflict.localError,
        sp.id
      )
    )
    yield put(
      createSystemNotification({
        notificationMessage: spConflict.globalError,
        notificationType: NOTIFICATION_ERROR,
        notificationId: SP_EDITOR_VALIDITY_NOTIFY,
        persistent: true,
      })
    )
  }
}

function* checkSPValidity(action) {
  const { supportParameter, supportParameters, spUri } = action
  const entities = pathOr(null, ['data', 'entities'], action)
  const currSPs = yield select(getCurrRPSPs)
  if (!isNil(supportParameters)) {
    yield all(supportParameters.map((param) => helper(param, currSPs)))
  } else if (!isNil(entities) && entities.supportParameters) {
    yield all(
      Object.values(entities.supportParameters).map((param) =>
        helper(param, currSPs)
      )
    )
  } else {
    const sp = yield select((state) =>
      getSPOnly(state, {
        uri: (supportParameter && supportParameter.uri) || spUri,
      })
    )
    yield helper(sp, currSPs)
  }
}
